import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { permissionTypes } from 'drapcode-constant';
import * as actions from './redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomLoader from '../common/CustomLoader';
import CustomReactPaginate from '../../common/custom/CustomReactPaginate';
import SettingTable from './SettingTable';
import { checkCodeExportPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
import ExportNav from './ExportNav';

export class DefaultPage extends Component {
  static propTypes = {
    deploymentSetting: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = { limit: 25 };

  componentDidMount() {
    const { match, actions } = this.props;
    const { projectId } = match.params;
    const { limit } = this.state;
    actions.listDeploymentSetting({ projectId, limit, page: 0 });
  }

  onPageChange = (val) => {
    const { projectId, version, actions, activeTab } = this.props;
    const { limit } = this.state;
    actions
      .listDeploymentSetting({
        projectId,
        page: val.selected,
        limit,
      })
      .then(() => {
        this.setState({
          page: val.selected,
        });
      });
  };

  showSettingsTable = () => {
    const { deploymentSetting, common, match, actions, history } = this.props;
    const { projectId, version } = match.params;
    const { projectDetail } = common;
    const { settings, totalSettings, currentSettingPage } = deploymentSetting;
    if (!settings || settings.length === 0) {
      return <p>No Deployment Setting</p>;
    }
    return (
      <div className="table-responsive">
        <table className="table table-bordered table-hover table-sm table-word-break">
          <thead>
            <tr>
              <th>Name</th>
              <th>Domain</th>
              <th>Api Domain</th>
              <th>Project Config Database</th>
              <th>Item Database Config</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {settings.map((setting) => (
              <SettingTable
                key={setting.uuid}
                setting={setting}
                projectId={projectId}
                version={version}
                page={this.state.page}
                actions={actions}
                history={history}
                projectDetail={projectDetail}
              />
            ))}
          </tbody>
        </table>
        {totalSettings > 1 && (
          <CustomReactPaginate
            totalPages={totalSettings}
            pageRangeDisplayed={5}
            marginPagesDisplayed={2}
            page={currentSettingPage}
            onPageChange={this.onPageChange}
          />
        )}
      </div>
    );
  };

  // upgradeAccountEmail = () => {
  //   const { actions, match } = this.props;
  //   const { projectId } = match.params;
  //   actions.requestUpgradeAccount({ projectId, code: permissionTypes.CODE_EXPORT });
  // };

  render() {
    const isAllowed = checkCodeExportPermission();
    if (!isAllowed) {
      return (
        <CommonPageComponent>
          <PermissionDenied message="Code Export" />
        </CommonPageComponent>
      );
    }

    const { deploymentSetting, match } = this.props;
    const { projectId, version } = match.params;
    const { listDeploymentSettingPending, projectDetail } = deploymentSetting;
    const projectType = projectDetail && projectDetail.projectType ? projectDetail.projectType : '';

    return (
      <CommonPageComponent>
        <ExportNav activeTab={'deployment'} version={version} projectId={projectId} />

        <ParentContentCard
          isSearch={false}
          icon="deployment"
          title="Deployment Setting"
          headerLink={`/deployment-setting/${version}/v/${projectId}/create`}
          headerTitle="Create Deployment Setting"
          headerText="Create"
          projectId={projectId}
          version={version}
        >
          {listDeploymentSettingPending ? (
            <div className="text-center">
              <CustomLoader loading={listDeploymentSettingPending} size="20px" color="#303453" />
            </div>
          ) : (
            this.showSettingsTable()
          )}
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    deploymentSetting: state.deploymentSetting,
    common: state.common,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultPage);
